import type {Location} from '@malt/nuxt-common-components-module/types';
import {useGlobalMatching} from './useGlobalMatching';
import {type Layer, useLocale} from '#imports';
import {buildDefaultLocationSuggestions} from '../utils/defaultLocationSuggestions';

function useDefaultLocationSuggestions() {
    const {countryCode} = useLocale();
    const {isBrowsingGlobalMatching} = useGlobalMatching();

    async function getDefaultLocationSuggestions(layers: Layer[], remoteCountryLabel?: string | null): Promise<Location[]> {
        const suggestions = await buildDefaultLocationSuggestions({
            remoteLabel: remoteCountryLabel,
            globalMatching: isBrowsingGlobalMatching.value ?? false,
            countryCode: countryCode?.value,
            layers,
        });
        return suggestions;
    }

    return {getDefaultLocationSuggestions};
}

export default useDefaultLocationSuggestions;
